module.exports = __webpack_public_path__ + "static/img/05.8880b58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/02-productCenter-assetsM/05.jpg
// module id = FRGX
// module chunks = 1